<div class="page-header-container">
  <md-page-header title="{{ 'NAV.CARCASS_COLLECTION_CUSTOMERS' | translate }}"></md-page-header>
</div>
